module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Francis George Heath\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Francis George Heath")]), _vm._v(" (1843-1913) is the author of "), _c('I', [_vm._v("Tree Lore")]), _vm._v(" (1912) and many other books, such as "), _c('I', [_vm._v("Our Woodland Trees, Autumnal Leaves, Peasant Life")]), _vm._v(" and "), _c('I', [_vm._v("Fairy Plants")]), _vm._v(". Heath was an enthusiastic lover of nature, and interested a large number of people in tress, plants and shrubery through his poetic language and descriptions of the natural world.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AF0mG/tc-custom/9781446358542.jpg?1705766049257",
      "alt": "This image is the cover for the book Tree Lore, The Paranormal"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tree Lore, The Paranormal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Francis George Heath has gathered together a fascinating collection of facts about trees, and arranged them in alphabetical order for the easy reference of readers. From aboriginal trees to Zelcona wood, Heath has covered all you could want to know about trees. Heath believes that the considerable amount of information in this ebook will often be new even to those well-informed readers."), _c('br'), _vm._v("The Paranormal, the new ebook series from F&W Media International Ltd, resurrecting rare titles, classic publications and out-of-print texts, as well as new ebook titles on the supernatural - other-worldly books for the digital age. The series includes a range of paranormal subjects from angels, fairies and UFOs to near-death experiences, vampires, ghosts and witchcraft.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    F+W Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0